import { MovieRemoveIcon } from './MovieRemoveIcon';

/**
 * author: Colton Wiscombe
 * id A55FA4A8-DD49-4A4E-8DC0-ED7979F2469B
 * name movie-remove
 * version: 5.9.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/movie-remove.svg
 * tags
 * - Video / Movie 
 */
export const FilmRemoveIcon = MovieRemoveIcon;
export default FilmRemoveIcon